import detailDefault from '../../detailDefault';

export default class detailaon_model_and_software_updates extends detailDefault {
    load(sAction, data) {
        // call immediately after detailView is load
        this.updateFieldDefs(sAction, data.prefix, sAction.dataGet(data.prefix + '/fields/visibility/value'));
    }

    update(sAction, data) {
        // call immediately after detailView field is update
        if (data.field === 'visibility') {
            this.updateFieldDefs(sAction, data.prefix, data.value);
        }
    }

    updateFieldDefs(sAction, prefix, visibility) {
        sAction.dsClear();
        sAction.dsAdd('set', prefix + '/fields/aon_list_of_models_aon_model_and_software_updates_1_name/def/required', visibility === 'private');
        sAction.dsProcess();
    }
}
